export default (a, b) => {
  if (a.name.replace(/\d+/, '') === b.name.replace(/\d+/, '') && a.name.match(/\d+/) && b.name.match(/\d+/)) {
    return parseInt(a.name.match(/\d+/)[0]) < parseInt(b.name.match(/\d+/)[0]) ? -1 : 1;
  } else {
    return a.name < b.name ? -1 : 1;
  }
};
